import React from 'react';

function CTA() {
  return (
    <section className="cta-section">
      <div className="container">
        <div className="cta-content fade-in">
          <h2>Ready to Transform Your Workforce Management?</h2>
          <p>
            Join organizations that have already streamlined their scheduling,
            reduced conflicts, and boosted team productivity with 9works.
          </p>
          <div className="cta-buttons">
            <a href="https://9works.in/organisation-portal" className="btn btn-primary btn-large" target="_blank" rel="noopener noreferrer">
              Get Started Free
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
            </a>
            <a href="#features" className="btn btn-ghost btn-large" onClick={(e) => { e.preventDefault(); document.getElementById('features')?.scrollIntoView({ behavior: 'smooth' }); }}>
              Learn More
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default CTA;
